/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 断点续传下载
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  pointDownloadDto: oss.PointDownloadDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "put",
    url: `/oss/breakPoint`,
    data: pointDownloadDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
